export default "__VITE_ASSET__vlqEdkEo__"